.textarea {
  composes: input from '../TextField/TextField.module.css';
  min-height: 88px;
  resize: vertical;
  line-height: var(--leading-normal);
}

.invalid {
  composes: invalid from '../TextField/TextField.module.css';
}
